import type { LevelDefinition } from "@/domain";

import {
  followDirectionsLevels,
  type FollowDirectionsPayload
} from "./follow-directions";
import {
  friendshipStoriesLevels,
  type FriendshipStoriesPayload
} from "./friendship-stories";
import {
  targetSearchLevels,
  type TargetSearchPayload
} from "./target-search";

export {
  FOCUS_SOCIAL_ACTIVITY_TYPES,
  type FocusSocialActivityType
} from "./create-level";
export {
  followDirectionsLevels,
  type DirectionStepDefinition,
  type DirectionTargetDefinition,
  type FollowDirectionsPayload
} from "./follow-directions";
export {
  FRIENDSHIP_TOPICS,
  friendshipStoriesLevels,
  type FriendshipChoiceDefinition,
  type FriendshipStoriesPayload,
  type FriendshipTopic
} from "./friendship-stories";
export {
  targetSearchLevels,
  type SearchObjectDefinition,
  type TargetSearchPayload,
  type TargetSearchRoundDefinition
} from "./target-search";

export type FocusSocialPayload =
  | TargetSearchPayload
  | FollowDirectionsPayload
  | FriendshipStoriesPayload;

export const focusSocialLevels: LevelDefinition<FocusSocialPayload>[] = [
  ...targetSearchLevels,
  ...followDirectionsLevels,
  ...friendshipStoriesLevels
];
